<template>
  <div class="w-100 h-100">
    <b-container fluid>
      <h2 class="tw-mb-0 text-aegis-dk">
        Subject Enrollment Details
      </h2>
      <p class="tw-italic tw-text-gray-700">
        Filter subject enrollment data by various parameters.
      </p>
    </b-container>

    <b-container fluid>
      <b-row>
        <b-col cols="3">
        </b-col>
        <b-col cols="3">
          <b-form-select
            size="lg"
            v-model="selectedClusterNumber"
            :options="clusterNumbers"
          ></b-form-select>
        </b-col>
        <b-col cols="3">
          <b-form-select
            size="lg"
            v-model="subject_enrollment"
            :options="subject_enrollment_options"
          ></b-form-select>
        </b-col>
        <b-col cols="auto">
          <h2>
            <b-badge>
              {{options.totalRows}}
            </b-badge>
          </h2>
        </b-col>
        <b-col cols="auto">
          <b-button size="lg" @click="download()">
            Download
          </b-button>
        </b-col>
      </b-row>
    </b-container>
    <br>

    <!-- loading alert -->
    <b-alert v-if="dataLoading" variant="info" show>Loading...<i class="fas fa-spin fa-spinner"></i></b-alert>

    <b-table
      ref="table"
      striped
      hover
      responsive
      :items="data"
      :fields="fields"
      :busy.sync="loading"
      :current-page="options.currentPage"
      :per-page="options.perPage"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
    >
        <template v-slot:cell(subject_age)="data">
            {{roundAge(data.value)}}
        </template>
        <template v-slot:cell(subject_age_at_enrollment)="data">
            {{roundAge(data.value)}}
        </template>
    </b-table>

    <b-pagination
      v-model="options.currentPage"
      :total-rows="options.totalRows"
      :per-page="options.perPage"
      align="right"
      size="sm"
      class="my-0"
    ></b-pagination>
  </div>
</template>

<script>
import { HTTP } from "@/utilities/http-common";
import HandleErrors from "@/utilities/handle-errors";

import DashboardBaseTemplate from "@/layouts/DashboardBaseTemplate.vue";

import * as _ from 'lodash';

export default {
  mixins: [DashboardBaseTemplate],
  data() {
    return {
      options: {
        currentPage: 1,
        totalRows: 0,
        perPage: 20
      },
      loading: false,
      search: "",
      selectedClusterNumber: "",
      clusterNumbers: [],
      fields: [],
      data: [],
      sortBy: "id",
      sortDesc: false,
      title: "",
      totalItems: 0,
      stacked: false,
      subject_enrollment: "Enrolled",
      subject_enrollment_options: [
        "Enrolled",
        "LTFU"
      ],
      dataLoading: false
    };
  },
  watch: {
    selectedClusterNumber: function() {
    //   this.$refs.table.refresh();
      this.find();
    },
    subject_enrollment: function() {
    //   this.$refs.table.refresh();
      this.find();
    },

  },
  created() {
    this.clusterNumbers = [{value: "", text: "All Clusters"}];
    for(let x = 1; x <= 34; x++) {
      this.clusterNumbers.push({value: x, text: x});
    }

    this.find();
  },
  methods: {
    find() {
      const that = this;

      that.dataLoading = true

      HTTP.get("/uganda/metrics/subject-enrollment-details", {
        params: {
          cluster_number: that.selectedClusterNumber,
          subject_enrollment: that.subject_enrollment,
        }
      })
        .then(response => {

          let fields = [];
          _.each(response.data.fields, function(field) {
            fields.push({
              key: field,
              sortable: true
            });
          });
          that.fields = fields;

          that.data = response.data.data;
          that.options.totalRows = parseInt(response.data.total);

          that.dataLoading = false

        })
        .catch(error => {
          HandleErrors.HandleErrors(error);
          that.dataLoading = false
        });
    },
    download() {
      const that = this;

      let csv = '';
      let fields = _.values(_.mapValues(that.fields, 'key'));

      csv += fields.join(',') + '\n';

      _.each(that.data, function(item) {
        let row = [];
        _.each(fields, function(field) {
          row.push(item[field]);
        });
        csv += row.join(',') + '\n';
      });

      var hiddenElement = document.createElement('a');
      hiddenElement.href = 'data:text/csv;charset=utf-8,' + encodeURI(csv);
      hiddenElement.target = '_blank';
      hiddenElement.download = `Subject-Enrollment-Details-${that.subject_enrollment}-${new Date().toLocaleDateString('en-CA')}.csv`;
      hiddenElement.click();
    },
    roundAge(age) {
      let num = parseFloat(age);
      return _.isNaN(num) ? 0.0 : _.floor(num, 1);
    }
  }
};
</script>

<style></style>
